import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export class MilkmanFreshFoodApi {
	constructor () {
		this.params = {
			"publishableKey": "milk_pub_syyFrcQm0tHnLG1j", //process.env.VUE_APP_MILKMAN_KEY,
			"subsidyCost": 0,			
			"numberOfDays": 2,
			// "deliveryDeadline": 24
		}
		this.url = process.env.NODE_ENV === 'development'
  			? 'https://api.mlkfreshandfood.milkmantechnologies.com/v2'
   			: 'https://api.mlkfreshandfood.milkmantechnologies.com/v2'
	}

	get (vars) {
		var params = {...this.params, ...vars.params}
		// return Vue.http.post(this.url + '/defineAvailability', params)
    return Vue.http.post("https://sigma.quomi.it:8214/v1/localization/milkman-fresh/availability", params) // temp fix
	}
}


